<template>
  <div :class="$store.getters.platform === 'browser' ? 'page-bg-browser' : 'page-bg'"  v-bg="{image: content.background, alternative: true, dir: 'to right'}">
    <video-bg v-if="content.trailer" ref="videoBG" :src="content.trailer" :bg="content.background"></video-bg>

    <app-loader v-if="loading"></app-loader>
    <div v-else>

      <div :id="'cont-' + content.id" class="wrapper-data">
        <router-link to="/content/">
          <div class="img">
            <img :src="$store.getters.getData.logo_mono">
          </div>
        </router-link>

        <div class="text">
          <h2 class="text-black-shadow">{{content.name}}</h2>
          <!-- <p v-if="content.duration" class="text-black-shadow" style="font-size: 1rem;">{{content.duration }}</p> -->
          <p v-if="content.publish_date" class="text-black-shadow" style="font-size: 1rem;">{{ $t("CONTENT.PUBLISHING") }}: {{publishDate}}</p>
          <p class="text-black-shadow"><pre>{{content.description | truncateText(500) }}</pre></p>
          <p v-if="lockedAdmin" class="text-black-shadow" style="margin-bottom: .5rem;">{{ $t("CONTENT-DETAIL.MSG-ADMIN") }}</p>
          <!-- <a v-if="content.trailer" v-on:click="trailer" v-on:keyup.enter="trailer" class="waves-effect waves-light btn-large focusable" tabindex="-1" v-on:keyup.down="down">Trailer</a> -->

          <div v-if="loadApi" class="content-icons">
            <a v-if="!locked"  v-on:click="play(false)" v-on:keyup.enter="play(false)" class="waves-effect waves-light btn-large focusable" tabindex="-1"><icon name="play" scale="1.5" class="margin-icon"></icon>{{ $tc("CONTENT.PLAY", content.second_view === null) }}</a>
            <a v-if="!locked && content.second_view"  v-on:click="play(true)" v-on:keyup.enter="play(true)" class="waves-effect waves-light btn-large focusable" tabindex="-1"><icon name="play" scale="1.5" class="margin-icon"></icon>{{ $t("CONTENT.PLAY-CONTINUE") }}</a>
            <a v-if="locked && !lockedAdmin"  v-on:click="checkPurchase" v-on:keyup.enter="checkPurchase" class="waves-effect waves-light btn-large focusable" tabindex="-1">{{price | currencyFormatter(currency)}}</a>

            <a v-if="$store.getters.getData.is_favorite && $store.getters.user"  v-on:click="toFavorites" v-on:keyup.enter="toFavorites" class="waves-effect waves-light btn-large focusable" tabindex="-1">
                <icon v-if="waiting" name="spinner" spin class="center-icon"></icon>
                <icon v-if="!waiting && !content.is_favorite" name="regular/heart" class="center-icon"></icon>
                <icon v-if="!waiting && content.is_favorite" name="heart" class="center-icon"></icon>
            </a>
          </div>
        </div>
        <hr :style="{ backgroundColor: $store.getters.getData.color1 }">

        <!-- productos relacionados -->

        <!-- contenidos relacionados -->
        <div style="overflow: hidden;">
          <app-list v-if="content.related_contents && content.related_contents.length"
            :options="{
              id: 'related-contents-' + content.id,
              type: routeList,
              title: $i18n.t('CONTENT-DETAIL.CONTENTS'),
              items: content.related_contents,
              route: routeList,
              style: 'margin-top: 1rem;',
              wrapper: $el,
              backReplace: true
            }"
            @trailerPlay="pauseTrailer"
            @trailerStop="playTrailer"
          />
        </div>

        <Modal v-if="showModal" @close="closeModal">
          <!-- modal dialog -->
          <p slot="body">{{ textDialog }}</p>

          <a slot="footer" @click="closeModal" class="waves-effect waves-light btn-large modal-focusable" style="    margin-right: .5rem;">{{ $t("GENERAL.CANCEL") }}</a>

          <a v-if="showModal === 'login'" slot="footer" @click="goLogin" class="waves-effect waves-light btn-large modal-focusable">Login</a>
          <a v-if="showModal === 'suscription'" slot="footer" @click="goUpdate" class="waves-effect waves-light btn-large modal-focusable">{{ $t("GENERAL.ACCEPT") }}</a>

        </Modal>

      </div>

    </div>
  </div>
</template>

<script>
import Bus from '@/components/ControlBus'
import Loader from '@/components/Loader'
import List from '@/components/List'
import {StatsContentDetail, enviroment} from '@/utils/constants'
import VideoBg from '@/components/video-bg'
import Modal from '@/components/Modal'
import { setLocation, getLocation } from '@/utils/helper-functions'
const contentsService = require('@/services/contents.js')

export default {
  name: 'ContentDetailTmpl',
  components: {
    'app-loader': Loader,
    'app-list': List,
    'video-bg': VideoBg,
    Modal
  },
  data () {
    return {
      content: {},
      showModal: false,
      keys: [
        {text: this.$i18n.t('KEYS.BACK'), action: this.$i18n.t('KEYS.RETURN')},
        {text: this.$i18n.t('KEYS.OK'), action: this.$i18n.t('KEYS.SELECT')},
        {color: 'yellow', action: this.$i18n.t('KEYS.HOME')}
      ],
      waiting: false,
      loadApi: false
    }
  },
  created: function () {
    const fromStore = parseInt(this.$route.params.id) === this.$store.getters.contentStackTop.id
    if (fromStore) {
      // content store
      let content = this.$store.getters.contentStackTop
      content.trailer = false
      this.content = content
    }
    // content server
    this.getGeolocation(fromStore)
  },
  mounted: function () {
    // control keys
    Bus.$on('key-back', this.keyBack)
    Bus.$on('key-yellow', this.keyYellow)
  },
  methods: {
    getGeolocation (fromStore) {
      let location = getLocation(this.$store.getters.getData.is_zones)
      if (location) {
        this.getContent(fromStore, location.lat, location.lon)
      } else {
        if (navigator.geolocation && !window.webOS) {
          // obtenemos geolocalización (LG no lo permite)
          let options = {
            enableHighAccuracy: false,
            timeout: 8000,
            maximumAge: Infinity
          }
          navigator.geolocation.getCurrentPosition(
            (position) => {
              setLocation({lat: position.coords.latitude, lon: position.coords.longitude})
              this.getContent(fromStore, position.coords.latitude, position.coords.longitude)
            },
            () => { this.getContent(fromStore, 0, 0) },
            options)
        } else {
          this.getContent(fromStore, 0, 0)
        }
      }
    },
    getContent (fromStore, lat, lon) {
      this.lat = lat
      this.lon = lon

      contentsService.getContent(this.$route.params.id, lat, lon).then(response => {
        this.content = response.data
        this.loadApi = true

        window.Countly.q.push(['track_pageview', StatsContentDetail + ' ' + this.content.id + ': ' + this.content.name])
      })
    },
    trailer () { this.$router.push({name: 'content-trailer', params: { id: this.content.id }}) },
    play (tracking) {
      if (!this.content.content_resources.length && !this.$store.getters.user) {
        this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
        this.showModal = 'login'
      } else if (!this.content.content_resources.length && this.$store.getters.user) {
        this.textDialog = this.$i18n.t('CONTENT-DETAIL.MSG-SUS')
        this.showModal = 'suscription'
      } else {
        if (this.$router.currentRoute.name === 'search-content-detail') {
          // from search
          this.$router.push({name: 'search-content-view', params: { id: this.content.id }, query: { tracking: tracking }})
        } else {
          // from contents
          this.$router.push({name: 'content-view', params: { id: this.content.id }, query: { tracking: tracking }})
        }
      }
    },
    playTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.play() },
    pauseTrailer () { if (this.$refs.videoBG) this.$refs.videoBG.pause() },
    checkPurchase () {
      if (!this.$store.getters.user) {
        this.textDialog = this.$i18n.t('GENERAL.REQUIERE-LINK')
        this.showModal = 'dialog'
      } else {
        this.purchase()
      }
    },
    purchase () {
      this.$store.commit('setPurchase', {
        type: 'cnt',
        id: this.content.id,
        'inna': this.content.inapppurchase.id,
        'price': this.content.inapppurchase.price
      })
      if (this.$router.currentRoute.name === 'search-content-detail') {
        // from search
        this.$router.push({name: 'search-purchase-summary-content'})
      } else {
        // from contents
        this.$router.push({name: 'purchase-summary-content'})
      }
    },
    keyBack: function () {
      if (!document.getElementById('app-modal')) {
        this.$store.commit('contentStackPop')
        // retrocedemos a home
        // this.$router.replace({name: 'content'})
        this.$router.replace({name: 'content'})
      }
    },
    keyYellow: function () { },
    closeModal: function () { this.showModal = false },
    goLogin: function () { this.$router.push({name: 'login-browser'}) },
    goUpdate: function () {
      let env = enviroment
      if (enviroment === 'api' || enviroment === 'api-pinko') { env = 'portal' }
      window.location.href = 'https://' + env + '.interactvty.com/tv/' + this.$store.getters.getData.name + '/?rt=' + this.$store.getters.getRefreshToken
    },
    toFavorites: function () {
      if (!this.waiting) {
        this.waiting = true
        if (!this.content.is_favorite) {
          contentsService.addFavorites({content: this.content.id}).then(response => {
            this.content.is_favorite = response.data.id
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'add-favorite', idFav: this.content.is_favorite })
            this.$store.getters.getData.content.is_favorite = response.data.id
          }).catch(() => {
            this.waiting = false
          })
        } else {
          contentsService.deleteFavorites(this.content.is_favorite).then(response => {
            this.content.is_favorite = 0
            this.waiting = false
            Bus.$emit('update-list', { item: this.content, action: 'remove-favorite' })
            this.$store.getters.getData.content.is_favorite = 0
          }).catch(() => {
            this.waiting = false
          })
        }
      }
    }
  },
  computed: {
    loading: function () {
      return Object.keys(this.content).length === 0
    },
    locked: function () {
      return this.content.is_premium && !this.content.is_paid
    },
    lockedAdmin: function () {
      return this.content.is_premium && !this.content.is_paid && this.content.inapppurchase.is_manual
    },
    routeList: function () {
      if (this.$router.currentRoute.name === 'search-content-detail') { return 'search-content-detail' }
      return 'content-detail'
    },
    typeList: function () {
      if (this.$router.currentRoute.name === 'search-content-detail') { return 'search-card-contents' }
      return 'card-contents'
    },
    price: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.content.inapppurchase.price * this.$store.getters.user.exchange : this.content.inapppurchase.price
    },
    currency: function () {
      return (this.$store.getters.user && this.$store.getters.user.country2) ? this.$store.getters.user.country2.currency : this.$store.getters.getData.currency
    },
    publishDate: function () {
      const date = new Date(this.content.publish_date)
      const day = date.getDate()
      const month = date.getMonth() + 1
      const year = date.getFullYear()

      if (month < 10) return `${day}-0${month}-${year}`
      return `${day}-${month}-${year}`
    }
  },
  beforeDestroy: function () {
    Bus.$off('key-back', this.keyBack)
    Bus.$off('key-yellow', this.keyYellow)
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>

.wrapper-data
  position: relative;
  min-height: 22vh;

  .img
    float: right;
    max-width: 22vw;
    max-height: inherit;
    padding-right: 2rem;
    margin-top: 1rem;
    min-width: 156px;

    img
      max-width: 100%;
      height: auto;
      max-height: inherit;

  .text
    max-width: 60%;
    min-height: 57vh;
    min-width: 300px;
    clear: both;
    color: white;
    padding: 1rem;
    margin-left: 2rem;

    h2
      font-size: 2.3rem;
      font-weight: 500;
      margin: 0 0 .3rem 0!important;
      word-wrap: break-word;

    p
      font-size: 1.4rem;
      line-height: 1.4;
      margin: 0 0 .3rem 0;

      pre
        white-space: pre-wrap
        font-family: "Roboto"

  .locked
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100vw;
    height: 30vh;
    text-align: center;

  hr
    height: .3rem!important;
    display: block;
    padding: 0;
    margin: 0;
    height: 0;
    border: 0;

.center-icon
  font-size: 3rem
  display: inline-flex;
  vertical-align: middle;

.content-icons
  a
    margin: .2rem 0rem

  .margin-icon
    margin-right: .5rem;

</style>



// WEBPACK FOOTER //
// src/templates/default/contents/content-detail.vue